import React from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { IImage } from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';
import { IVideoModalProps } from '../VideoModal';
import ContentTileEvent from './ContentTileEvent';
import ContentTileArticle from './ContentTileArticle';
import ContentTileVideo from './ContentTileVideo';

export interface IContentTileProps extends IBaseElementProps {
	tileType?: 'Event' | 'Article' | 'Video';
	maxWidth?: number;
	minHeight?: number;
	tileImage?: IImage;
	tileReadTime?: string;
	tileHeading?: string;
	tileLocation?: string;
	tileDate?: string;
	tileTags?: ILink[];
	tileDescription?: string;
	tileLink?: ILink;
	tileVideo?: IVideoModalProps;
	/**
	 * @noUI
	 */
	inverted?: boolean;
}

/**
 * Calian Content Tile
 * @icon index-card
 * @block
 */
const ContentTile: React.FC<IContentTileProps> = ({
	id,
	className,
	classNames = [],
	tileType,
	maxWidth,
	minHeight,
	tileImage,
	tileReadTime,
	tileHeading,
	tileLocation,
	tileDate,
	tileTags,
	tileDescription,
	tileLink,
	tileVideo,
	inverted = false,
}) => {
	let content = null;

	switch (tileType) {
		case 'Event':
			content = (
				<ContentTileEvent
					{...{
						tileImage,
						tileHeading,
						tileLocation,
						tileDate,
						tileTags,
						tileDescription,
						tileLink,
						inverted,
					}}
				/>
			);
			break;
		case 'Article':
			content = (
				<ContentTileArticle
					{...{
						tileLink,
						tileImage,
						tileReadTime,
						tileHeading,
						tileLocation,
						tileDate,
						tileTags,
						tileDescription,
					}}
				/>
			);
			break;
		case 'Video':
			content = <ContentTileVideo {...{ tileHeading, tileVideo }} />;
			break;
	}
	return (
		<div
			id={id}
			className={
				className ||
				cn(
					'calian-content-tile',
					{
						[`tile-type-${kebabCase(tileType)}`]: tileType,
						[`inverted`]: inverted,
					},
					...classNames,
				)
			}
			style={{
				maxWidth: maxWidth ? `${maxWidth}px` : 'none',
				minHeight: minHeight ? `${minHeight}px` : 'none',
			}}
		>
			{content}
		</div>
	);
};

export default ContentTile;
